module.exports = __webpack_public_path__ + "static/meetLinda_2-8776cda196fd81139d93290d62ce8b1f.jpg";